import { render } from "./BlockTimeDashboard.vue?vue&type=template&id=3d62f936"
import script from "./BlockTimeDashboard.vue?vue&type=script&lang=js"
export * from "./BlockTimeDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BlockTimeDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d62f936"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d62f936', __exports__)) {
    api.reload('3d62f936', __exports__)
  }
  
  module.hot.accept("./BlockTimeDashboard.vue?vue&type=template&id=3d62f936", () => {
    api.rerender('3d62f936', render)
  })

}


export default __exports__